var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-breadcrumbs',{staticClass:"pb-0",attrs:{"items":_vm.breadcrumbs,"divider":">"},scopedSlots:_vm._u([{key:"item",fn:function({ item }){return [_c('v-breadcrumbs-item',{staticClass:"text-subtitle-2 crumb-item",attrs:{"to":item.to,"disabled":item.disabled,"exact":""}},[_vm._v(" "+_vm._s(item.text)+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }